export const buildDraft = (venueOwnerships, configMap) => {
  const draft = {};
  venueOwnerships.forEach((vo) => {
    const cfg = configMap[vo.id] || {};
    draft[vo.id] = {
      enabled: new Set(cfg.enabled_setting_ids || []),
      defaultId: cfg.default_setting_id || null,
    };
  });
  return draft;
};

export const cloneDraft = (draft) => {
  const out = {};
  Object.entries(draft).forEach(([k, v]) => {
    out[k] = { enabled: new Set(v.enabled), defaultId: v.defaultId };
  });
  return out;
};

export const draftDiff = (a, b) => {
  for (const vid of Object.keys(a)) {
    const x = a[vid];
    const y = b[vid] || { enabled: new Set(), defaultId: null };
    if (x.defaultId !== y.defaultId) return true;
    if (x.enabled.size !== y.enabled.size) return true;
    for (const id of x.enabled) if (!y.enabled.has(id)) return true;
  }
  return false;
};

export const cycleCellDraft = (draft, venueId, optionId) => {
  const next = cloneDraft(draft);
  const cfg = next[venueId];
  if (!cfg) return next;

  const isDefault = cfg.defaultId === optionId;
  const isEnabled = cfg.enabled.has(optionId);

  if (isDefault) {
    cfg.enabled.delete(optionId);
    cfg.defaultId = null;
  } else if (isEnabled) {
    cfg.defaultId = optionId;
  } else {
    cfg.enabled.add(optionId);
  }
  return next;
};

export const venueDraftDiffers = (a, b) => {
  if (!b) return true;
  if (a.defaultId !== b.defaultId) return true;
  if (a.enabled.size !== b.enabled.size) return true;
  for (const id of a.enabled) if (!b.enabled.has(id)) return true;
  return false;
};
